<template>
  <div class="communications">
    <div
      class="row grid-12"
    >
      <Button layout="green-go" @click="openComm = true">
        <i class="fa fa-plus" /> NOVO
      </Button>
    </div>

    <Comm :class="openComm ? 'open' : 'close'" />

    <div class="column" v-if="!loader">
      <div class="filters grid-12 column">
        <div class="row column-s">
          <div class="column grid-3 grid-12-s">
            Nome ou Título
            <input
              type="text"
              class="input"
              v-model="filter.nome"
              placeholder="Nome ou Título"
              @blur="getComms()"
              @keyup.enter="getComms()"
            />
          </div>
          <div class="column grid-3 grid-12-s">
            Usuários
            <select
              v-model="filter.tipo_usuario"
              class="input"
              @change="getComms()"
            >
              <option :value="undefined">Usuários</option>
              <option value="cliente">Clientes</option>
              <option value="doutor">Supporters</option>
              <option value="funcionario">Funcionários</option>
            </select>
          </div>
          <div class="column grid-3 grid-12-s">
            Em destaque
            <select
              class="input"
              v-model="filter.destaque"
              @change="getComms()"
            >
              <option :value="undefined">Em destaque</option>
              <option :value="false">Não</option>
              <option :value="true">Sim</option>
            </select>
          </div>
          <div class="column grid-3 grid-12-s">
            Publicado
            <select
              class="input"
              v-model="filter.publicado"
              @change="getComms()"
            >
              <option :value="undefined">Publicado</option>
              <option :value="false">Não</option>
              <option :value="true">Sim</option>
            </select>
          </div>
        </div>

        <div class="row column-s margin-top">
          <div class="column grid-3 grid-12-s">
            Data de criação
            <input
              type="date"
              class="input"
              v-model="filter.data_inicio_criacao"
            />
          </div>
          <div class="column grid-3 grid-12-s">
            Data fim criação
            <input
              type="date"
              class="input"
              v-model="filter.data_fim_criacao"
              @change="getComms()"
            />
          </div>
          <div class="column grid-3 grid-12-s">
            Data incial validade
            <input
              type="date"
              class="input"
              v-model="filter.data_inicio_validade"
            />
          </div>
          <div class="column grid-3 grid-12-s">
            Data fim validade
            <input
              type="date"
              class="input"
              v-model="filter.data_fim_validade"
              @change="getComms()"
            />
          </div>
        </div>
      </div>
      <div class="row wrap">
        <Card
          v-for="(comm, index) in communications"
          :key="'card' + index"
          :id="'card-' + comm.id"
          :comm="comm"
          @deleteComm="(id) => deleteComm(id)"
        />
      </div>
    </div>
    <div v-else class="column align-center justify-center">
      <Loader />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
import Card from "@/components/CardComm.vue";
import Comm from "@/components/Comm.vue";

export default {
  name: "Communications",
  components: { Button, Loader, Card, Comm },
  data() {
    return {
      loader: false,
      openComm: false,
      communications: [],
      filter: {},
    };
  },
  beforeMount() {
    let init = new Date();
    this.filter.data_fim_criacao = init.toISOString().slice(0, 10);
    init.setMonth(init.getMonth() - 1);
    this.filter.data_inicio_criacao = init.toISOString().slice(0, 10);
    this.getComms();
  },
  methods: {
    ...mapActions("admin", ["GET_COMMS"]),
    deleteComm(id) {
      document.getElementById("card-" + id).remove();
    },
    isValidDate(field) {
      if (
        (this.filter[field] && this.filter[field].length < 10) ||
        (this.filter[field] && Number(this.filter[field].split("-")[0]) < 2020)
      ) {
        this.loader = false;
        return false;
      }

      return true;
    },

    getComms() {
      this.loader = true;
      this.communications = [];
      if (!this.isValidDate("data_fim_criacao")) return false;
      if (!this.isValidDate("data_fim_validade")) return false;

      this.filter.titulo = this.filter.nome;

      this.GET_COMMS(this.filter)
        .then((r) => {
          this.communications = r.data || [];
          this.loader = false;
        })
        .catch(() => (this.loader = false));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.communications {
  padding: 42px 35px;
  @media (max-width: $small) {
    padding: 7px;
  }

  .filters {
    font-size: 12px;
    color: $gray-2;

    @media (min-width: $medium) {
      /* padding: 0px 30px; */
    }
    .input {
      margin-right: 30px;
      width: auto;
      @media (max-width: $small) {
        margin-bottom: 15px;
        /* padding: 0px 30px; */
      }
    }
  }
  .margin-top {
    margin-top: 15px;
  }
  .newComm {
    @media (min-width: $small) {
      margin-right: 27px;
    }
  }
}
</style>